export const ACTIONS = {
  INVENTORY_VARIANTS_FETCH_START: 'INVENTORY_VARIANTS_FETCH_START',
  INVENTORY_VARIANTS_FETCH_SUCCESS: 'INVENTORY_VARIANTS_FETCH_SUCCESS',
  INVENTORY_VARIANTS_FETCH_FAILURE: 'INVENTORY_VARIANTS_FETCH_FAILURE',
  INVENTORY_VARIANTS_FETCH_RESET: 'INVENTORY_VARIANTS_FETCH_RESET',

  INVENTORY_LOCATIONS_FETCH_START: 'INVENTORY_LOCATIONS_FETCH_START',
  INVENTORY_LOCATIONS_FETCH_SUCCESS: 'INVENTORY_LOCATIONS_FETCH_SUCCESS',
  INVENTORY_LOCATIONS_FETCH_FAILURE: 'INVENTORY_LOCATIONS_FETCH_FAILURE',
  INVENTORY_LOCATIONS_FETCH_RESET: 'INVENTORY_LOCATIONS_FETCH_RESET',

  INVENTORY_TRANSFER_CREATE_START: 'INVENTORY_TRANSFER_CREATE_START',
  INVENTORY_TRANSFER_CREATE_SUCCESS: 'INVENTORY_TRANSFER_CREATE_SUCCESS',
  INVENTORY_TRANSFER_CREATE_FAILURE: 'INVENTORY_TRANSFER_CREATE_FAILURE',
  INVENTORY_TRANSFER_CREATE_RESET: 'INVENTORY_TRANSFER_CREATE_RESET',
};
